import * as THREE from 'three';
import { jsondan } from '../FikoThreeType';
import { Fiko3DYaziIsaretleyici } from './Fiko3DYaziIsaretleyici';
import { FikoGrup } from './FikoGrup';
import { FikoSahne } from './FikoSahne';
import { FikoOperasyon } from './FikoThreeCam/Fikoperasyon';
import { FikoOperasyonlar } from './FikoThreeCam/Fikoperasyonlar';


export class Fiko3DIsaretleyiciler extends FikoGrup {
    override type: any = "Fiko3DIsaretleyiciler";
    /** */
    sayac = 1;

    sagButonlar = [
        {
            isim: "İşaretçi Ekle",
            simge: "plus",
            tiklandi: () => {
                this.ekleFikoIsaretci();
            }
        }
    ]

    public override get liste(): Fiko3DYaziIsaretleyici[] {
        return this.children as Fiko3DYaziIsaretleyici[];
    }

    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;
        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/bayrak.webp";
    }

    ekleFikoIsaretci(isim?: string): Fiko3DYaziIsaretleyici {
        // Default isim: parent'ın ismi (çizimin ismi)
        const parentIsim = this.parent?.name || 'Çizim';
        const defaultIsim = isim || `${parentIsim}.${this.sayac}`;

        let ekl = new Fiko3DYaziIsaretleyici(this.sahne, defaultIsim);
        ekl.name = defaultIsim;

        // Yazıyı da parent'ın ismi olarak ayarla (ekranda görünür)
        if (!isim) {
            ekl.setYazi(parentIsim);
            ekl.merkezle(); // Merkezi güncelle
        }

        this.sayac += 1;
        this.ekle(ekl) as Fiko3DYaziIsaretleyici
        return ekl;
    }

    override toJSON(): any {
        const _rslt: any = {
            type: this.type,
            isim: this.name,
            uuid: this.uuid,
            isaretleyiciler: []
        };

        for (let index = 0; index < this.children.length; index++) {
            const element = this.children[index];
            _rslt.isaretleyiciler.push(element.toJSON());
        }

        return _rslt;
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const _rslt = new Fiko3DIsaretleyiciler(sahne, json.isim);
        _rslt.uuid = json.uuid;
        _rslt.parent = parent;

        if (json.isaretleyiciler) {
            for (let i = 0; i < json.isaretleyiciler.length; i++) {
                let element = json.isaretleyiciler[i];
                _rslt.children[i] = jsondan(sahne, _rslt, element);
            }
        }

        return _rslt;
    }

}